import React from 'react';
import { CardContent, Avatar, Divider, Fade } from '@material-ui/core';
import cx from 'clsx';
import cloneDeep from 'lodash/cloneDeep';
import { uniqueKey } from '../../utils';
import { Questionnaire } from '../Questionnaire';
import { AnswerActions } from './AnswerActions';
import { AnswerCarousel, getPageIndex } from './AnswerCarousel';
import { AnswerContent } from './AnswerContent';
import { getOperatorEscalationUrl } from './getOperatorEscalationUrl';
import { buildSelectionPath, generateOrderedAnswersExcludeAnotherCards } from './utils';
var dividerStyle = { marginTop: 12, marginBottom: 12 };
function isRootCard(answer, cardId) {
    return answer.id === cardId;
}
function isCarouselCard(answer) {
    return answer.contents.some(function (c) { return Boolean(c.carousel); });
}
export var Answer = function (_a) {
    var contents = _a.contents, onClick = _a.onClick, cardId = _a.cardId, answers = _a.answers, operatorEscalationKeyword = _a.operatorEscalationKeyword, karakuriWebRootUrl = _a.karakuriWebRootUrl, messages = _a.messages, info = _a.info, session = _a.session, onFeedback = _a.onFeedback, skillApi = _a.skillApi;
    var _b = React.useState([cardId]), selectionPath = _b[0], setSelectionPath = _b[1];
    var _c = React.useMemo(function () {
        var actionList = [];
        var keyAssignmentAnswers = {};
        var actionActionMap = {};
        var defaultSelectSelectionState = {};
        answers.forEach(function (answer) {
            var _a;
            var actionActionIds = (((_a = answer === null || answer === void 0 ? void 0 : answer.actions) === null || _a === void 0 ? void 0 : _a.actions) || []).map(function (action) { return (action === null || action === void 0 ? void 0 : action.id) || ''; });
            actionList.push(actionActionIds);
            keyAssignmentAnswers[answer.id] = answer;
            var isAnswerSelect = actionActionIds.length > 0;
            if (isAnswerSelect) {
                // 選択肢ありカードの場合、answer.idとanswer.actions.idは同じ
                defaultSelectSelectionState[answer.id] = {
                    currentActionActionId: undefined,
                    actionIds: actionActionIds,
                };
                actionActionIds.forEach(function (actionActionId) {
                    actionActionMap[actionActionId] = answer.id;
                });
            }
        });
        var orderedAnswers = generateOrderedAnswersExcludeAnotherCards(keyAssignmentAnswers, [
            cardId,
        ]);
        return [keyAssignmentAnswers, orderedAnswers, defaultSelectSelectionState, actionActionMap];
    }, [answers, cardId]), keyAssignmentAnswers = _c[0], orderedAnswers = _c[1], defaultSelectSelectionState = _c[2], actionActionMap = _c[3];
    var _d = React.useState({}), carouselSelectionState = _d[0], setCarouselSelectionState = _d[1];
    var _e = React.useState({}), selectSelectionState = _e[0], setSelectSelectionState = _e[1];
    React.useEffect(function () {
        setSelectionPath([cardId]);
    }, [cardId]);
    var ensureSelectSelectionState = function (actionActionId) {
        var cloneSelectSelectionState = cloneDeep(selectSelectionState);
        var actionId = actionActionMap[actionActionId];
        if (!cloneSelectSelectionState[actionId]) {
            cloneSelectSelectionState[actionId] = defaultSelectSelectionState[actionId];
        }
        return cloneSelectSelectionState;
    };
    var updateSelectionPath = function (data) {
        if (data.carousel) {
            setSelectionPath(buildSelectionPath(cardId, keyAssignmentAnswers, data.carousel, selectSelectionState));
        }
        if (data.select) {
            setSelectionPath(buildSelectionPath(cardId, keyAssignmentAnswers, carouselSelectionState, data.select));
        }
    };
    var updateSelectActionActionId = function (actionActionId) {
        var ensuredSelectSelectionState = ensureSelectSelectionState(actionActionId);
        var actionId = actionActionMap[actionActionId];
        ensuredSelectSelectionState[actionId].currentActionActionId = actionActionId;
        setSelectSelectionState(ensuredSelectSelectionState);
        updateSelectionPath({ select: ensuredSelectSelectionState });
    };
    var onActionSelected = function (e, id, external, uri) {
        e.preventDefault();
        if (external) {
            if (uri) {
                return window.open(uri, '_blank', 'noopener,status=yes,scrollbars=yes,resizable=yes');
            }
            onClick("/answer/".concat(id));
        }
        else {
            updateSelectActionActionId(id);
        }
    };
    return (React.createElement("div", { className: "faq-answer-content-wrapper" },
        React.createElement(CardContent, { className: cx('faq-answer-content') },
            React.createElement(Avatar, { "aria-label": "Answer", className: cx('faq-answer-a', 'faq-answer-content__a') }, info ? 'i' : 'A'),
            contents && (React.createElement(AnswerContent, { cardId: cardId, className: "faq-answer-content__answer", contents: contents, skillApi: skillApi }))),
        React.createElement(React.Fragment, null, orderedAnswers && orderedAnswers.length > 0
            ? orderedAnswers.map(function (a) {
                if (!selectionPath.includes(a.id)) {
                    return null;
                }
                else if (isRootCard(a, cardId)) {
                    if (isCarouselCard(a)) {
                        return (React.createElement(React.Fragment, { key: uniqueKey('fragment-answer', cardId, a.id) }, a.contents.map(function (c) {
                            return c.carousel ? (React.createElement(AnswerCarousel, { key: uniqueKey('answer-carousel', cardId, a.id, c.carousel.id), index: getPageIndex(c.carousel.id, carouselSelectionState), baseClassName: "faq-answer-content__answer", carousel: c.carousel, skillApi: skillApi, answers: orderedAnswers, cardId: cardId, onClick: onClick, selectionPath: selectionPath, updateSelectionPath: updateSelectionPath, carouselSelectionState: carouselSelectionState, setCarouselSelectionState: function (state) { return setCarouselSelectionState(state); }, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, session: session })) : null;
                        })));
                    }
                    else {
                        return (React.createElement(AnswerActions, { key: uniqueKey('answer-actions', cardId, a.id), className: "faq-answer-content__button", cardId: cardId, answers: orderedAnswers, actions: a.actions || null, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session }));
                    }
                }
                else {
                    /* isChildCard */
                    return (React.createElement(Fade, { key: uniqueKey('fade-answer', cardId, a.id), in: selectionPath.includes(a.id) },
                        React.createElement(React.Fragment, null,
                            React.createElement(Divider, { key: uniqueKey('fade-divider-answer', cardId, a.id), variant: "middle", light: true, style: dividerStyle }),
                            React.createElement(AnswerContent, { key: uniqueKey('fade-answer-content', cardId, a.id), cardId: cardId, className: "faq-answer-content__answer", contents: a.contents, skillApi: skillApi }),
                            isCarouselCard(a) &&
                                a.contents.map(function (c) {
                                    return c.carousel ? (React.createElement(AnswerCarousel, { key: uniqueKey('answer-carousel', cardId, a.id, c.carousel.id), index: getPageIndex(c.carousel.id, carouselSelectionState), baseClassName: "faq-answer-content__answer", carousel: c.carousel, skillApi: skillApi, answers: orderedAnswers, cardId: cardId, onClick: onClick, selectionPath: selectionPath, updateSelectionPath: updateSelectionPath, carouselSelectionState: carouselSelectionState, setCarouselSelectionState: function (state) { return setCarouselSelectionState(state); }, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, session: session })) : null;
                                }),
                            !isCarouselCard(a) && (React.createElement(AnswerActions, { key: uniqueKey('answer-actions', cardId, a.id), className: "faq-answer-content__button", cardId: cardId, answers: orderedAnswers, actions: a.actions || null, selectionPath: selectionPath, operatorEscalationKeyword: operatorEscalationKeyword, karakuriWebRootUrl: karakuriWebRootUrl, onActionSelected: onActionSelected, session: session })))));
                }
            })
            : null),
        !info && (React.createElement(CardContent, null,
            React.createElement(Questionnaire, { cardId: cardId, onFeedback: onFeedback, messages: messages, operatorEscalationUrl: getOperatorEscalationUrl(cardId, orderedAnswers || [], selectionPath, karakuriWebRootUrl, operatorEscalationKeyword, session), skillApi: skillApi })))));
};
//# sourceMappingURL=Answer.js.map